import { render, staticRenderFns } from "./InstallationsStatistics.vue?vue&type=template&id=47fd1108&scoped=true&"
import script from "./InstallationsStatistics.vue?vue&type=script&lang=ts&"
export * from "./InstallationsStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsStatistics.vue?vue&type=style&index=0&id=47fd1108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd1108",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fd1108')) {
      api.createRecord('47fd1108', component.options)
    } else {
      api.reload('47fd1108', component.options)
    }
    module.hot.accept("./InstallationsStatistics.vue?vue&type=template&id=47fd1108&scoped=true&", function () {
      api.rerender('47fd1108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InstallationsStatistics.vue"
export default component.exports